import React from "react";

import { localizedText } from "shared/lib/localizedMap";
import { ConfirmDialog } from "shared/ui";

import { CategoriesOrderDialog } from "features/MenuEditor/components/CategoriesOrderDialog";
import { CategorySettingsDialog } from "features/MenuEditor/components/CategorySettingsDialog";
import { CopyItemDialog } from "features/MenuEditor/components/CopyItemDialog";
import { CreateCategoryDialog } from "features/MenuEditor/components/CreateCategoryDialog";
import { CreateItemDialog } from "features/MenuEditor/components/CreateItemDialog";
import { MenuManagementPanel } from "features/MenuEditor/components/MenuManagementPanel";
import { MoveItemDialog } from "features/MenuEditor/components/MoveItemDialog";
import { UploadItemsDialog } from "features/MenuEditor/components/UploadItemsDialog";
import { useMenuEditorContext } from "features/MenuEditor/context";

/*
* Диалоги монтируются только когда открыты: часть из них ходит в сеть при монтировании
* (список позиций для сортировки, категории другого меню для копирования), и держать их
* смонтированными всё время означало бы лишние запросы на каждом рендере экрана.
* */
export const MenuEditorDialogs = () => {
    const state = useMenuEditorContext();
    const { dialog, mutations, closeDialog } = state;

    switch (dialog.kind) {
        case "manage":
            return <MenuManagementPanel />;

        case "createCategory":
            return <CreateCategoryDialog />;

        case "categorySettings":
            return <CategorySettingsDialog />;

        case "categoriesOrder":
            return <CategoriesOrderDialog />;

        case "createItem":
            return <CreateItemDialog />;

        case "moveItem":
            return <MoveItemDialog />;

        case "copyItem":
            return <CopyItemDialog />;

        case "upload":
            return <UploadItemsDialog />;

        case "deleteCategory":
            return (
                <ConfirmDialog
                    open
                    title="Удалить категорию?"
                    description={`Категория «${localizedText(dialog.category.name, state.locale)}» и все её позиции (${dialog.category.itemsCount}) исчезнут из меню. Действие необратимо.`}
                    confirmLabel="Удалить"
                    saving={mutations.saving}
                    onClose={closeDialog}
                    onConfirm={async () => {
                        const deleted = await mutations.deleteCategory(dialog.category.id);
                        if (deleted) closeDialog();
                    }}
                />
            );

        case "deleteItem":
            return (
                <ConfirmDialog
                    open
                    title="Удалить позицию?"
                    description={`Позиция «${localizedText(dialog.item.name, state.locale)}» исчезнет из меню. Действие необратимо.`}
                    confirmLabel="Удалить"
                    saving={mutations.saving}
                    onClose={closeDialog}
                    onConfirm={async () => {
                        const deleted = await mutations.deleteItem(dialog.item.id);
                        if (deleted) closeDialog();
                    }}
                />
            );

        default:
            return null;
    }
};
